// Advanced Dropdown

bq.advancedDropdown = function(element, options) {
  this.options   = options;
  this.$element  = $(element);

};

bq.advancedDropdown.DEFAULTS = {
  attach: 'body',
  showEvent: 'shown.bs.dropdown',
  hideEvent: 'hidden.bs.dropdown',
  parentSelector: '.dropdown',
  dropdownSelector: '.dropdown-menu',
  dropdownWrapperSelector: '.dropdown-menu-wrapper',
  dropdownWidth: 230,
  align: 'right', //left or right
  offset: {top: -2, left: 0}
};

bq.advancedDropdown.prototype = {
  init: function() {
    bq.debug.log("Advanced Dropdown : init()", this.$element);

    //set up event catching
    this.$element.closest(this.options.parentSelector).on(this.options.showEvent, {thiz: this}, this._catchEventShow);
    this.$element.closest(this.options.parentSelector).on(this.options.hideEvent, {thiz: this}, this._catchEventHide);

  },

  _showDropdown: function(parent) {
    var $dropdown = false;

    if(parent.data('relatedDropdown')) {
        $dropdown = $('#'+parent.data('relatedDropdown'));
    } else {
        $dropdown = this._copyDropdown(parent);
    }

    var $offset = this._calculatePosition(parent);
    $dropdown.css({top: $offset.top+'px', left: $offset.left+'px'});

    if ($dropdown.is(this.options.dropdownWrapperSelector)) {
	    $dropdown.find(this.options.dropdownSelector).show();
    }

    $dropdown.show();
  },

  _animateMobileDropdown: function(close, dropdown, parent) {

    var isDropdownVisible = dropdown.is(":visible"),
        tableRow = parent.parents('tr'),
        rowHeight = tableRow.height(),
        dropdownHeight = dropdown.show().css({height: 'auto'}).height();

    if(close) {
        dropdown.hide();
        rowHeight = tableRow.data('origHeight');
        dropdown.show();

        parent.animate({
            height: rowHeight,
            width: parent.data('origWidth')
        }, 500);

        dropdown.animate({
            left: '100%'
        }, 500);

        $(tableRow).animate({
          'height': rowHeight
        }, 500);
    } else {

        tableRow.data('origHeight', rowHeight);
        parent.data('origWidth', parent.width());
        if(rowHeight > dropdownHeight) {
            dropdownHeight = rowHeight;
        }

        parent.animate({
            height: dropdownHeight,
            width: '100%'
        }, 500);

        dropdown.animate({
            left: '0'
        }, 500);

        $(tableRow).animate({
          'height': dropdownHeight
        }, 500);

    }
  },

  _calculatePosition: function(parent) {
    var $offset = this.$element.offset();
    var $top = this.$element.outerHeight();
    var top = $offset.top + this.options.offset.top + $top;
    var left = $offset.left + this.options.offset.left;

    if(this.options.align == 'right') {
      left = left - this.options.dropdownWidth + parent.outerWidth();
    }

    return {top: top, left: left};
  },

  _hideDropdown: function(parent) {
    if(parent.data('relatedDropdown') && !parent.data('mobile')) {
        var $dropdown = $('#'+parent.data('relatedDropdown'));
        $dropdown.hide();
    } else if(parent.data('relatedDropdown')) {
        var $dropdown = $('#'+parent.data('relatedDropdown'));
        this._animateMobileDropdown(true, $dropdown, parent);
    }

    var tableRow = parent.parents('tr');
    $(tableRow).stop().css('height', 'auto');
    $(tableRow).find('td').css('vertical-align', 'middle');
  },

  _copyModalDropdown: function(parent) {
    var tableRow = parent.parents('tr'),
        $dropdown = parent.find(this.options.dropdownWrapperSelector) || parent.find(this.options.dropdownSelector),
        id = bq.helper.uniqueId($dropdown);

    $dropdown.addClass('mobile-grid-dropdown');

    parent.data('relatedDropdown', id);

    return $dropdown;
  },

  _copyDropdown: function(parent) {
    var $dropdown = parent.find(this.options.dropdownWrapperSelector) || parent.find(this.options.dropdownSelector);
    $dropdown = $dropdown.appendTo(this.options.attach);
    var id = bq.helper.uniqueId($dropdown);

    parent.data('relatedDropdown', id);

    $dropdown.css({ //add some default styles
      display: 'none',
      position: 'absolute',
      top: 0,
      left: 0,
      width: this.options.dropdownWidth+'px'
    });

    return $dropdown;

  },

  _catchEventShow: function(e) {
    var $this = e.data.thiz;
    var parent = $(e.target);
    $this._showDropdown(parent);
  },

  _catchEventHide: function(e) {
    var $this = e.data.thiz;
    var parent = $(e.target);
    $this._hideDropdown(parent);
  }

};

// Advanced Dropdown PLUGIN DEFINITION
// =======================

var advancedDropdownold = $.fn.advancedDropdown;

$.fn.advancedDropdown = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.advancedDropdown');
    var options = $.extend({}, bq.advancedDropdown.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.advancedDropdown', (data = new bq.advancedDropdown(this, options))); }
    data.init();
  });
};

$.fn.advancedDropdown.Constructor = bq.advancedDropdown;

// Advanced Dropdown NO CONFLICT
// =================

$.fn.advancedDropdown.noConflict = function () {
  $.fn.advancedDropdown = advancedDropdownold;
  return this;
};

// Advanced Dropdown DATA-API
// ==============

bq.advancedDropdownInit = function() {
    $('[data-bq="advanced-dropdown"]').each(function () {
      var el = $(this);
      if(el.data('bq.advancedDropdown')) { return; }
      el.advancedDropdown(el.data());
    });
};


bq.init.push(bq.advancedDropdownInit);
